__turbopack_context__.v({
  "modalContent": "FolderSharingModal-module__qv7JpW__modalContent",
  "typeahead": "FolderSharingModal-module__qv7JpW__typeahead",
});
